import { isNumber, isNil } from 'lodash';

export const hasSupply = (options = []) => {
    const { count } = options[0] || {};

    return isNil(count) || (isNumber(count) && count > 0);
};
